<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. Early American Seafaring</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Preparing to Sail</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Perils at Sea</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Death at Sea</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Remembrance</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Living Alongside the Sea</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Stories from the Stones</span></p>
<p class="toc1"><span href="#/epilogue" title="Link target outside of Sample">Epilogue. A Ship Lost, Another Reborn</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f511602e